import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";

import { Modal } from "@lib/modal";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import BetDetailsStore from "@state/stores/my-bets/BetDetailsStore";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { BetSlipShareDetails } from "@state/stores/my-bets/BetSlipShareDetailsStore";

export default observer(function CashoutMessageModal(props: {
	store: MyBetsStore | BetDetailsStore | BetSlipShareDetails;
}) {
	const { t } = useTranslation();
	const methods = useForm();

	const { register, handleSubmit } = methods;

	const onSubmit = (data: OpenCashoutModalType) => {
		if (props.store.cashoutStore.cashoutModalData) {
			props.store.cashoutStore.cashout(
				{
					id: props.store.cashoutStore.cashoutModalData?.id,
					calculatedCashoutAmount:
						props.store.cashoutStore.cashoutModalData
							?.calculatedCashoutAmount,
					displayedAmount:
						props.store.cashoutStore.cashoutModalData
							.displayedAmount || "",
					userId: props.store.cashoutStore.cashoutModalData.userId,
					cType: props.store.cashoutStore.cashoutModalData?.cType,
					isLive: props.store.cashoutStore.cashoutModalData?.isLive,
					isChangeAccepted: data.isChangeAccepted || false,
					liveBetSlipCountdown:
						props.store.cashoutStore.cashoutModalData
							?.liveBetSlipCountdown,
				},
				CashoutLocation.MY_BETS
			);
		}
	};

	return (
		<Modal>
			<FormProvider {...methods}>
				<form
					onSubmit={handleSubmit(onSubmit)}
					id="cashout-form"
					className="popup"
				>
					<div className="popup__card">
						<div className="popup__header">
							{t<string>("mybets:CASHOUT.TITLE")}
						</div>

						<div className="popup__body">
							<InfoMessageComponent
								type="warning"
								size="sml"
								message={
									props.store.cashoutStore.cashoutModalData
										?.message
								}
							/>
							<div className="form__group input--check u-mar--top--xsml">
								<input
									id="isChangeAccepted"
									className="input--check__box"
									type="checkbox"
									{...register("isChangeAccepted")}
								/>
								<label
									className="input--check__label"
									htmlFor="isChangeAccepted"
								>
									{t<string>(
										"mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT"
									)}
								</label>
							</div>
						</div>

						<div className="popup__footer">
							<button
								id="close"
								className="at-cashoutModalSecondaryBtn popup__btn popup__btn--secondary btn btn--base btn--primary--inverted"
								type="button"
								onClick={
									props.store.cashoutStore.closeCashoutModal
								}
							>
								{t<string>("COMMON.CANCEL")}
							</button>
							<button
								className="at-cashoutModalPrimaryBtn popup__btn popup__btn--primary btn btn--base btn--success"
								type="submit"
							>
								{t<string>("mybets:CASHOUT.TITLE")}
							</button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Modal>
	);
});
